export enum UserStatus {
  PENDING_INVITE = "PENDING_INVITE",
  INVITED = "INVITED",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
